define(['okta/underscore', 'shared/framework/Collection'], function (_, Collection) {
  /**
  * @class Okta.Collection
  * @extend Archer.Collection
  * @inheritDoc Archer.Collection
  */
  return Collection.extend({

    /**
     * Is the end point using the legacy "secureJSON" format
     * @type {Function|Boolean}
     */
    secureJSON: false,

    constructor: function () {
      if (_.result(this, 'secureJSON')) {
        this.sync = _.wrap(this.sync, function (sync, method, collection, options) {
          return sync.call(this, method, collection, _.extend({dataType: 'secureJSON'}, options));
        });
      }
      Collection.apply(this, arguments);
    }

  });
});



/** WEBPACK FOOTER **
 ** ./target/js/shared/models/BaseCollection.js
 **/